/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Contract Management API
 * API for Contract management UI.
 * OpenAPI spec version: 1.0.0-Draft
 */
import * as zod from 'zod';


/**
 * Header and contracts come from the BFF's copy of Payment's agreements. The schedule and overviews are read from Payment on each call; schedule is null when Payment is unavailable.
 * @summary Gets a payment agreement with its contracts and payment schedule
 */
export const getAgreementPathAgreementIdMin = 3;
export const getAgreementPathAgreementIdMax = 32;



export const GetAgreementParams = zod.object({
  "agreementId": zod.string().min(getAgreementPathAgreementIdMin).max(getAgreementPathAgreementIdMax)
})

export const getAgreementResponseAgreementIdMin = 3;
export const getAgreementResponseAgreementIdMax = 32;

export const getAgreementResponseCustomerAgreementIdMin = 3;
export const getAgreementResponseCustomerAgreementIdMax = 64;

export const getAgreementResponseDealerAgreementIdMin = 3;
export const getAgreementResponseDealerAgreementIdMax = 64;

export const getAgreementResponseDealershipIdMin = 3;
export const getAgreementResponseDealershipIdMax = 32;

export const getAgreementResponseDealerNameOneMax = 200;

export const getAgreementResponseContractsItemVinMin = 8;
export const getAgreementResponseContractsItemVinMax = 17;

export const getAgreementResponseContractsItemPaymentAgreementOneAgreementIdMin = 3;
export const getAgreementResponseContractsItemPaymentAgreementOneAgreementIdMax = 32;

export const getAgreementResponseContractsItemPaymentAgreementOneCustomerAgreementIdMin = 3;
export const getAgreementResponseContractsItemPaymentAgreementOneCustomerAgreementIdMax = 64;

export const getAgreementResponseContractsItemPaymentAgreementOneDealerAgreementIdMin = 3;
export const getAgreementResponseContractsItemPaymentAgreementOneDealerAgreementIdMax = 64;

export const getAgreementResponseContractsItemPolicyNumberMax = 100;

export const getAgreementResponseContractsItemDealerAccountRegExp = new RegExp('^[0-9]{6}$');
export const getAgreementResponseContractsItemCustomerNameOneMax = 200;

export const getAgreementResponseContractsItemContractStartOdometerValueMin = 0;

export const getAgreementResponseContractsItemContractEndOdometerValueMin = 0;

export const getAgreementResponseContractsItemContractEngineHoursLimitMin = 0;

export const getAgreementResponseScheduleOneCustomerNameOneMax = 200;


export const getAgreementResponseScheduleOnePaymentsItemAmountCurrencyMin = 2;
export const getAgreementResponseScheduleOnePaymentsItemAmountCurrencyMax = 3;

export const getAgreementResponseScheduleOnePaymentsItemAmountAmountMultipleOf = 0.01;

export const getAgreementResponseScheduleOnePaymentsItemLinesItemVinMin = 17;
export const getAgreementResponseScheduleOnePaymentsItemLinesItemVinMax = 17;

export const getAgreementResponseScheduleOnePaymentsItemLinesItemContractNumberMin = 3;
export const getAgreementResponseScheduleOnePaymentsItemLinesItemContractNumberMax = 64;

export const getAgreementResponseScheduleOnePaymentsItemLinesItemServiceDescriptionMin = 3;
export const getAgreementResponseScheduleOnePaymentsItemLinesItemServiceDescriptionMax = 64;

export const getAgreementResponseScheduleOnePaymentsItemLinesItemNetAmountCurrencyMin = 2;
export const getAgreementResponseScheduleOnePaymentsItemLinesItemNetAmountCurrencyMax = 3;

export const getAgreementResponseScheduleOnePaymentsItemLinesItemNetAmountAmountMultipleOf = 0.01;

export const getAgreementResponseScheduleOnePaymentsItemLinesItemMarkupAmountCurrencyMin = 2;
export const getAgreementResponseScheduleOnePaymentsItemLinesItemMarkupAmountCurrencyMax = 3;

export const getAgreementResponseScheduleOnePaymentsItemLinesItemMarkupAmountAmountMultipleOf = 0.01;

export const getAgreementResponseScheduleOneCustomerPaymentsContractsTotalCurrencyMin = 2;
export const getAgreementResponseScheduleOneCustomerPaymentsContractsTotalCurrencyMax = 3;

export const getAgreementResponseScheduleOneCustomerPaymentsContractsTotalAmountMultipleOf = 0.01;

export const getAgreementResponseScheduleOneCustomerPaymentsNetTotalCurrencyMin = 2;
export const getAgreementResponseScheduleOneCustomerPaymentsNetTotalCurrencyMax = 3;

export const getAgreementResponseScheduleOneCustomerPaymentsNetTotalAmountMultipleOf = 0.01;

export const getAgreementResponseScheduleOneCustomerPaymentsPaidCurrencyMin = 2;
export const getAgreementResponseScheduleOneCustomerPaymentsPaidCurrencyMax = 3;

export const getAgreementResponseScheduleOneCustomerPaymentsPaidAmountMultipleOf = 0.01;

export const getAgreementResponseScheduleOneCustomerPaymentsRemainingCurrencyMin = 2;
export const getAgreementResponseScheduleOneCustomerPaymentsRemainingCurrencyMax = 3;

export const getAgreementResponseScheduleOneCustomerPaymentsRemainingAmountMultipleOf = 0.01;

export const getAgreementResponseScheduleOneCustomerPaymentsPaymentsRemainingMin = 0;

export const getAgreementResponseScheduleOneDealerCommissionsTotalCurrencyMin = 2;
export const getAgreementResponseScheduleOneDealerCommissionsTotalCurrencyMax = 3;

export const getAgreementResponseScheduleOneDealerCommissionsTotalAmountMultipleOf = 0.01;

export const getAgreementResponseScheduleOneDealerCommissionsCreditedCurrencyMin = 2;
export const getAgreementResponseScheduleOneDealerCommissionsCreditedCurrencyMax = 3;

export const getAgreementResponseScheduleOneDealerCommissionsCreditedAmountMultipleOf = 0.01;

export const getAgreementResponseScheduleOneDealerCommissionsRemainingCurrencyMin = 2;
export const getAgreementResponseScheduleOneDealerCommissionsRemainingCurrencyMax = 3;

export const getAgreementResponseScheduleOneDealerCommissionsRemainingAmountMultipleOf = 0.01;



export const GetAgreementResponse = zod.object({
  "agreementId": zod.string().min(getAgreementResponseAgreementIdMin).max(getAgreementResponseAgreementIdMax),
  "customerAgreementId": zod.string().min(getAgreementResponseCustomerAgreementIdMin).max(getAgreementResponseCustomerAgreementIdMax),
  "dealerAgreementId": zod.string().min(getAgreementResponseDealerAgreementIdMin).max(getAgreementResponseDealerAgreementIdMax),
  "dealershipId": zod.string().min(getAgreementResponseDealershipIdMin).max(getAgreementResponseDealershipIdMax),
  "dealerName": zod.string().min(1).max(getAgreementResponseDealerNameOneMax).nullable(),
  "paymentFrequencies": zod.array(zod.enum(['Monthly', 'Yearly'])),
  "contracts": zod.array(zod.object({
  "id": zod.uuid(),
  "vin": zod.string().min(getAgreementResponseContractsItemVinMin).max(getAgreementResponseContractsItemVinMax),
  "paymentAgreement": zod.object({
  "agreementId": zod.string().min(getAgreementResponseContractsItemPaymentAgreementOneAgreementIdMin).max(getAgreementResponseContractsItemPaymentAgreementOneAgreementIdMax),
  "customerAgreementId": zod.string().min(getAgreementResponseContractsItemPaymentAgreementOneCustomerAgreementIdMin).max(getAgreementResponseContractsItemPaymentAgreementOneCustomerAgreementIdMax),
  "dealerAgreementId": zod.string().min(getAgreementResponseContractsItemPaymentAgreementOneDealerAgreementIdMin).max(getAgreementResponseContractsItemPaymentAgreementOneDealerAgreementIdMax),
  "planStatus": zod.enum(['Active', 'Cancelled']).describe('Active means the contract is paid over time.')
}).describe('The payment agreement the contract was sold under, found through its VIN and policy (directly or as part of a bundle).').nullable(),
  "policyNumber": zod.string().min(1).max(getAgreementResponseContractsItemPolicyNumberMax),
  "coverageType": zod.string().nullable().nullable(),
  "dealerAccount": zod.string().regex(getAgreementResponseContractsItemDealerAccountRegExp),
  "customerName": zod.string().min(1).max(getAgreementResponseContractsItemCustomerNameOneMax).nullable(),
  "startDate": zod.iso.date(),
  "expiryDate": zod.iso.date(),
  "cancellationDate": zod.iso.date().nullable(),
  "contractStartOdometer": zod.object({
  "value": zod.number().min(getAgreementResponseContractsItemContractStartOdometerValueMin),
  "unit": zod.enum(['miles', 'kilometers'])
}),
  "contractEndOdometer": zod.object({
  "value": zod.number().min(getAgreementResponseContractsItemContractEndOdometerValueMin),
  "unit": zod.enum(['miles', 'kilometers'])
}),
  "contractEngineHoursLimit": zod.number().min(getAgreementResponseContractsItemContractEngineHoursLimitMin).nullish()
})),
  "schedule": zod.object({
  "customerName": zod.string().min(1).max(getAgreementResponseScheduleOneCustomerNameOneMax).nullable(),
  "payments": zod.array(zod.object({
  "number": zod.number().min(1),
  "amount": zod.object({
  "currency": zod.string().min(getAgreementResponseScheduleOnePaymentsItemAmountCurrencyMin).max(getAgreementResponseScheduleOnePaymentsItemAmountCurrencyMax),
  "amount": zod.number().multipleOf(getAgreementResponseScheduleOnePaymentsItemAmountAmountMultipleOf).describe('The amount of currency, with two decimal precision')
}),
  "invoiceDate": zod.iso.date(),
  "dueDate": zod.iso.date(),
  "invoiceNumbers": zod.array(zod.string()),
  "status": zod.enum(['Scheduled', 'Pending', 'Paid']).describe('Paid when every invoice of the payment is fully collected. Otherwise Scheduled when no invoice is billed yet, else Pending. Whether a Pending payment is overdue depends on the viewer\'s calendar day and its due date, so the consumer decides it. An invoice counts as fully collected when its collects cover its net plus markup, as in Payment.'),
  "receivedDate": zod.iso.date().nullable(),
  "lines": zod.array(zod.object({
  "vin": zod.string().min(getAgreementResponseScheduleOnePaymentsItemLinesItemVinMin).max(getAgreementResponseScheduleOnePaymentsItemLinesItemVinMax),
  "contractNumber": zod.string().min(getAgreementResponseScheduleOnePaymentsItemLinesItemContractNumberMin).max(getAgreementResponseScheduleOnePaymentsItemLinesItemContractNumberMax).describe('The plan\'s contract number in Payment.'),
  "serviceDescription": zod.string().min(getAgreementResponseScheduleOnePaymentsItemLinesItemServiceDescriptionMin).max(getAgreementResponseScheduleOnePaymentsItemLinesItemServiceDescriptionMax).describe('The policy number, or the WPTP860 bundle number for a bundled plan, as Payment holds it.'),
  "netAmount": zod.object({
  "currency": zod.string().min(getAgreementResponseScheduleOnePaymentsItemLinesItemNetAmountCurrencyMin).max(getAgreementResponseScheduleOnePaymentsItemLinesItemNetAmountCurrencyMax),
  "amount": zod.number().multipleOf(getAgreementResponseScheduleOnePaymentsItemLinesItemNetAmountAmountMultipleOf).describe('The amount of currency, with two decimal precision')
}),
  "markupAmount": zod.object({
  "currency": zod.string().min(getAgreementResponseScheduleOnePaymentsItemLinesItemMarkupAmountCurrencyMin).max(getAgreementResponseScheduleOnePaymentsItemLinesItemMarkupAmountCurrencyMax),
  "amount": zod.number().multipleOf(getAgreementResponseScheduleOnePaymentsItemLinesItemMarkupAmountAmountMultipleOf).describe('The amount of currency, with two decimal precision')
}),
  "invoiceNumber": zod.string().nullable().describe('Null until the line is invoiced.')
})).describe('One line per plan billed on this payment\'s invoice date, ordered by contract number.')
})).describe('One payment per invoice date of the agreement, numbered from the earliest. Billed payments carry invoice numbers. Invoices of cancelled plans that were never billed are left out.'),
  "customerPayments": zod.object({
  "contractsTotal": zod.object({
  "currency": zod.string().min(getAgreementResponseScheduleOneCustomerPaymentsContractsTotalCurrencyMin).max(getAgreementResponseScheduleOneCustomerPaymentsContractsTotalCurrencyMax),
  "amount": zod.number().multipleOf(getAgreementResponseScheduleOneCustomerPaymentsContractsTotalAmountMultipleOf).describe('The amount of currency, with two decimal precision')
}),
  "netTotal": zod.object({
  "currency": zod.string().min(getAgreementResponseScheduleOneCustomerPaymentsNetTotalCurrencyMin).max(getAgreementResponseScheduleOneCustomerPaymentsNetTotalCurrencyMax),
  "amount": zod.number().multipleOf(getAgreementResponseScheduleOneCustomerPaymentsNetTotalAmountMultipleOf).describe('The amount of currency, with two decimal precision')
}),
  "paid": zod.object({
  "currency": zod.string().min(getAgreementResponseScheduleOneCustomerPaymentsPaidCurrencyMin).max(getAgreementResponseScheduleOneCustomerPaymentsPaidCurrencyMax),
  "amount": zod.number().multipleOf(getAgreementResponseScheduleOneCustomerPaymentsPaidAmountMultipleOf).describe('The amount of currency, with two decimal precision')
}),
  "remaining": zod.object({
  "currency": zod.string().min(getAgreementResponseScheduleOneCustomerPaymentsRemainingCurrencyMin).max(getAgreementResponseScheduleOneCustomerPaymentsRemainingCurrencyMax),
  "amount": zod.number().multipleOf(getAgreementResponseScheduleOneCustomerPaymentsRemainingAmountMultipleOf).describe('The amount of currency, with two decimal precision')
}),
  "paymentsRemaining": zod.number().min(getAgreementResponseScheduleOneCustomerPaymentsPaymentsRemainingMin).describe('Payments not yet fully collected (Scheduled and Pending).')
}),
  "dealerCommissions": zod.object({
  "total": zod.object({
  "currency": zod.string().min(getAgreementResponseScheduleOneDealerCommissionsTotalCurrencyMin).max(getAgreementResponseScheduleOneDealerCommissionsTotalCurrencyMax),
  "amount": zod.number().multipleOf(getAgreementResponseScheduleOneDealerCommissionsTotalAmountMultipleOf).describe('The amount of currency, with two decimal precision')
}),
  "credited": zod.object({
  "currency": zod.string().min(getAgreementResponseScheduleOneDealerCommissionsCreditedCurrencyMin).max(getAgreementResponseScheduleOneDealerCommissionsCreditedCurrencyMax),
  "amount": zod.number().multipleOf(getAgreementResponseScheduleOneDealerCommissionsCreditedAmountMultipleOf).describe('The amount of currency, with two decimal precision')
}),
  "remaining": zod.object({
  "currency": zod.string().min(getAgreementResponseScheduleOneDealerCommissionsRemainingCurrencyMin).max(getAgreementResponseScheduleOneDealerCommissionsRemainingCurrencyMax),
  "amount": zod.number().multipleOf(getAgreementResponseScheduleOneDealerCommissionsRemainingAmountMultipleOf).describe('The amount of currency, with two decimal precision')
})
})
}).nullable().describe('Null when Payment is unavailable.'),
  "status": zod.enum(['Active', 'Unfulfilled', 'Fulfilled']).nullable().describe('Unfulfilled when every plan is cancelled. Otherwise Fulfilled when every scheduled payment is paid, else Active. Null when Payment is unavailable and not every plan is cancelled.')
})

/**
 * Streams the signed document from the Signing service, using the customer or dealer agreement id as the signing reference.
 * @summary Downloads the signed customer or dealer agreement
 */
export const downloadAgreementDocumentPathAgreementIdMin = 3;
export const downloadAgreementDocumentPathAgreementIdMax = 32;



export const DownloadAgreementDocumentParams = zod.object({
  "agreementId": zod.string().min(downloadAgreementDocumentPathAgreementIdMin).max(downloadAgreementDocumentPathAgreementIdMax),
  "party": zod.enum(['customer', 'dealer'])
})

